'use strict';

import axios from 'axios';

// Config

let config = {
  env:     process.env.NODE_ENV || 'development',
  version: 'v1'
};

const configure = ({env, version}) => {
  if (env) config.env = env;
  if (version) config.version = version;
};

const baseUrl = () => {
  return config.env === 'production' ?
      'https://version-2.pinhigh.co' :
      'http://192.168.86.26:4004';
};

const version = () => {
  return config.version;
};


// API calls

const Login = {
  create: ({params}) => axios.post(`${baseUrl()}/api/${version()}/logins.json`, params).then(response => response.data.response)
};

const PasswordReset = {
  create: ({params}) => axios.post(`${baseUrl()}/api/${version()}/password_resets.json`, params).then(response => response.data.response)
};

const Registration = {
  create: ({params}) => axios.post(`${baseUrl()}/api/${version()}/registrations.json`, params).then(response => response.data.response)
};

const StripeCard = {
  destroy: ({params}) => {
    return axios.delete(
      `${baseUrl()}/api/${version()}/stripe_cards/${params.id}.json?`
    ).then(response => response.data.response);
  }
};

const UserConfirmation = {
  create: ({params}) => axios.post(`${baseUrl()}/api/${version()}/user_confirmations.json`, params).then(response => response.data.response),
  destroy: ({params}) => {
    return axios.delete(
      `${baseUrl()}/api/${version()}/user_confirmations/${params.userConfirmation.email_verification}.json?user_confirmation[email]=${params.userConfirmation.email}`
    ).then(response => response.data.response);
  }
};

const Contact = {
  create: ({params}) => axios.post(`${baseUrl()}/api/${version()}/contacts.json`, params).then(response => response.data.response)
};

const Payment = {
  create: ({params}) => axios.post(`${baseUrl()}/api/${version()}/payments.json`, params).then(response => response.data.response),
  index: ({params}) => axios.get(`${baseUrl()}/api/${version()}/payments.json`, {params}).then(response => response.data.response)
};

const PoolParticipationOffer = {
  create: ({params}) => {
    return axios.post(
      `${baseUrl()}/api/${version()}/pool_participation_offers.json`,
      params
    ).then(response => response.data.response);
  },
  destroy: ({params}) => {
    return axios.delete(
      `${baseUrl()}/api/${version()}/pool_participation_offers/${params.id}.json`
    ).then(response => response.data.response);
  },
  index: ({params}) => axios.get(`${baseUrl()}/api/${version()}/pool_participation_offers.json`, {params}).then(response => response.data.response)
};

const Comment = {
  create: ({params}) => axios.post(`${baseUrl()}/api/${version()}/comments.json`, params).then(response => response.data.response),
  destroy: ({params}) => axios.delete(`${baseUrl()}/api/${version()}/comments/${params.comment.id}.json`, {params}).then(response => response.data.response),
  index: ({params}) => axios.get(`${baseUrl()}/api/${version()}/comments.json`, {params}).then(response => response.data.response)
};

const UpcomingTournament = {
  index: () => axios.get(`${baseUrl()}/api/${version()}/upcoming_tournaments.json`).then(response => response.data.response)
};

const TournamentField = {
  show: ({params}) => axios.get(`${baseUrl()}/api/${version()}/tournament_fields/${params.id}.json`).then(response => response.data.response)
};

const OwnedPool = {
  index: ({params}) => axios.get(`${baseUrl()}/api/${version()}/owned_pools.json`, {params}).then(response => response.data.response)
};

const Pool = {
  create: ({params}) => axios.post(`${baseUrl()}/api/${version()}/pools.json`, params).then(response => response.data.response),
  update: ({params}) => axios.patch(`${baseUrl()}/api/${version()}/pools/${params.pool.id}.json`, params).then(response => response.data.response),
  destroy: ({params}) => axios.delete(`${baseUrl()}/api/${version()}/pools/${params.pool.id}.json`, params).then(response => response.data.response),
  show: ({params}) => axios.get(`${baseUrl()}/api/${version()}/pools/${params.id}.json`).then(response => response.data.response),
  index: ({params}) => axios.get(`${baseUrl()}/api/${version()}/pools.json`, {params}).then(response => response.data.response)
};

const ParticipationSuggestion = {
  index: ({params}) => axios.get(`${baseUrl()}/api/${version()}/participation_suggestions.json`, {params}).then(response => response.data.response)
};

const PoolParticipationSuggestion = {
  index: () => axios.get(`${baseUrl()}/api/${version()}/pool_participation_suggestions.json`).then(response => response.data.response)
};

const DashboardPool = {
  index: () => axios.get(`${baseUrl()}/api/${version()}/dashboard_pools.json`).then(response => response.data.response)
};

const Picks = {
  update: ({params}) => axios.patch(`${baseUrl()}/api/${version()}/picks/${params.id}.json`, params).then(response => response.data.response)
};

const TournamentPlayerRounds = {
  index: ({params}) => axios.get(`${baseUrl()}/api/${version()}/tournament_player_rounds.json`, {params}).then(response => response.data.response)
};

const User = {
  update: ({params}) => axios.patch(`${baseUrl()}/api/${version()}/users/${params.id}.json`, params).then(response => response.data.response),
  show: ({params}) => axios.get(`${baseUrl()}/api/${version()}/users/${params.id}.json`).then(response => response.data.response)
};

const PoolStats = {
  show: ({params}) => axios.get(`${baseUrl()}/api/${version()}/pool_stats/${params.id}.json`).then(response => response.data.response)
};

const Admin = {
  User: {
    index: ({params}) => axios.get(`${baseUrl()}/api/${version()}/admin/users.json`, {params}).then(response => response.data.response)
  }
};

export default {
  configure,
  Login,
  PasswordReset,
  Registration,
  UserConfirmation,
  Contact,
  Payment,
  PoolParticipationOffer,
  Comment,
  UpcomingTournament,
  TournamentField,
  OwnedPool,
  Pool,
  ParticipationSuggestion,
  PoolParticipationSuggestion,
  DashboardPool,
  Picks,
  TournamentPlayerRounds,
  StripeCard,
  User,
  PoolStats,
  Admin
};
